// removed by extract-text-webpack-plugin
module.exports = {"horizontal-container":"GlobalHeader__horizontal-container","horizontalContainer":"GlobalHeader__horizontal-container","globe-desktop":"GlobalHeader__globe-desktop","globeDesktop":"GlobalHeader__globe-desktop","globe-mobile":"GlobalHeader__globe-mobile","globeMobile":"GlobalHeader__globe-mobile"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalHeader/GlobalHeader.mobile.css
// module id = 1390
// module chunks = 8